import { useCallback, useState } from 'react';
import type { RawData } from '../../types';
import { SelectHeaderTable } from '../SelectHeaderTable';
import Button from 'common/components/button/Button';
import { useTranslation } from 'react-i18next';
import { useRsi } from '../../hooks/useRsi';
type SelectHeaderProps = {
  data: RawData[];
  selectedRow: ReadonlySet<number>;
  onContinue: (headerValues: RawData, data: RawData[], selectedRow: ReadonlySet<number>) => Promise<void>;
  onPrevious: () => Promise<void>;
};

export const SelectHeaderStep = ({ data, onContinue, onPrevious, selectedRow }: SelectHeaderProps) => {
  const { onClose } = useRsi();
  const [selectedRows, setSelectedRows] = useState<ReadonlySet<number>>(selectedRow);
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();

  const handleContinue = useCallback(async () => {
    const [selectedRowIndex] = Array.from(selectedRows);
    // We consider data above header to be redundant
    const trimmedData = data.slice(selectedRowIndex + 1);
    setIsLoading(true);
    await onContinue(data[selectedRowIndex], trimmedData, selectedRows);
    setIsLoading(false);
  }, [onContinue, data, selectedRows]);

  return (
    <>
      <div className="spreadsheet-step-scroll" style={{ flex: 1, overflow: 'auto' }}>
        <b>{t('spreadsheet_import.select_header_step.msg')}</b>
        <div style={{ flexGrow: 1, marginTop: 20 }}>
          <SelectHeaderTable data={data} selectedRows={selectedRows} setSelectedRows={setSelectedRows} />
        </div>
      </div>
      {isLoading ? (
        <>{'Loading...'}</>
      ) : (
          <div style={{ textAlign: 'right', paddingTop: 20, flexShrink: 0 }}>
            <Button preset={'secondary'} type="button" onClick={() => onClose()} text={t('common.cancel')} />
            <Button type="button" onClick={() => onPrevious()} text={t('spreadsheet_import.select_header_step.previous_button_title')} />
            <Button onClick={() => handleContinue()}>
              {t('spreadsheet_import.select_header_step.next_button_title')}
            </Button>
          </div>
        )}
    </>
  );
};
